<mat-menu>
  @if (redigeringMulig() && !mappe().erRotMappe) {
    <button mat-menu-item (click)="rediger()" data-testid="rediger-knapp">
      <mat-icon>edit</mat-icon>
      {{ 'Rediger'|translate }}
    </button>
    <button mat-menu-item (click)="flytt()">
      <mat-icon>move_down</mat-icon>
      {{ 'Flytt'|translate }}
    </button>
    <button mat-menu-item (klikk)="slett()" [bekreftKlikk]="'Ja, slett mappen' | translate" data-testid="slett">
      <mat-icon fontSet="ion-ios-trash" class="mat-icon--ionic-ikon"/>
      {{ 'Slett'|translate }}
    </button>
  }
  <button mat-menu-item (click)="visSkjerming()">
    <mat-icon>visibility_lock</mat-icon>
    {{ 'Vis tilganger'|translate }}
  </button>
  @if (redigeringMulig()) {
    <button mat-menu-item (click)="redigerSkjerming()">
      <mat-icon>visibility_lock</mat-icon>
      {{ 'Rediger tilgang'|translate }}
    </button>
    <mat-divider/>
  }
  @if (leggTilNyNodeMulig()){
    <button mat-menu-item (click)="nyMappe()">
      <mat-icon>create_new_folder</mat-icon>
      {{ 'Ny mappe'|translate }}
    </button>
    <button mat-menu-item (click)="nyttDokument()">
      <mat-icon>note_add</mat-icon>
      {{ 'Nytt dokument'|translate }}
    </button>
    <button mat-menu-item (click)="importerArkivFraZip()">
      <mat-icon>cloud_upload</mat-icon>
      {{ 'Importer fra zip-fil'|translate }}
    </button>
  }
</mat-menu>


<!--dialog som vises dersom mappe ikke kan slettes -->
<ng-template #mappeKanIkkeSlettesDialogTemplate>
  <div class="mappe-kan-ikke-slettes-dialog" data-testid="mappe-kan-ikke-slettes-dialog">
    <h2 mat-dialog-title>{{ "Mappen '{mappenavn}' kan ikke slettes"|translate:{mappenavn: mappe().navn} }}</h2>
    <mat-dialog-content>
      <p>{{ "Mappen eller undermapper inneholder følgende dokumenter som er registrert som saksdokument." | translate }}</p>
      <ul>
        @for (dokument of kanIkkeSlettesPgaBrukISaker(); track dokument.dokumentVersjon.id) {
          <li class="dokumenter">
            <a (click)="gaaTilDokument(dokument.dokumentVersjon)"> {{ dokument.dokumentVersjon.filnavn }} </a>
            <span>{{ 'behandles i følgende saker:' | translate }}</span>
            <ul class="saker">
              @for (sak of dokument.tilknyttedeSaker; track sak.id) {
                <li>
                  <a (click)="gaaTilSak(sak)" data-testid="gå-til-sak">
                    <span>
                      {{ "Sak {sakstittel} i {moetetittel} {moetedato}"|translate : {sakstittel: sak.tittel, moetetittel: sak.moete.tittel, moetedato: sak.moete.dato.start|zoneddatetimeSomPlaindate|plaindate} }}
                    </span>
                    <mat-icon inline="true">arrow_forward</mat-icon>
                  </a>
                </li>
              }
            </ul>
          </li>
        }
      </ul>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
      <button mat-button mat-dialog-close>{{ "Lukk"|translate }}</button>
    </mat-dialog-actions>
  </div>
</ng-template>


<!--dialog som vises dersom mappe som slettes inneholder barn -->
<ng-template #slettMappeMedBarnDialogTemplate>
  <div class="slett-mappe-med-barn-dialog" data-testid="slett-mappe-med-barn-dialog">
    <h2 mat-dialog-title>{{ "Bekreft sletting av mappen '{mappenavn}'"|translate:{mappenavn: mappe().navn} }}</h2>
    <mat-dialog-content>
      <p>{{ "Følgende underelementer vil også bli slettet" | translate }}</p>
      <ul>
        @for (barn of barnAvMappeSomSlettes(); track barn.id) {
          <li>
            <mat-icon>{{ barn.erMappe ? 'folder' : 'draft' }}</mat-icon>
            <span>{{ barn.navn }}</span>
          </li>
        }
      </ul>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
      <button mat-button [mat-dialog-close]="false">{{ "Avbryt"|translate }}</button>
      <button mat-raised-button color="warn" [mat-dialog-close]="true">{{ "Slett alt"|translate }}</button>
    </mat-dialog-actions>
  </div>
</ng-template>

